export const LOGIN_ROUTE = "/login";
export const REGISTER_ROUTE = "/signup";
export const PROFILE_ROUTE = "/login";
export const HOME_ROUTE = "/";